import styles from '../_signup.module.scss'
import { t } from '../../../utils/i18n'
import classnames from 'classnames'
import Image from 'next/legacy/image'
import drummerImg from '@public/images/drummer.png'

interface AccountProps {
  register: any
  errors: any
  handleContinue?: any
  password: any
  isSubmitted?: boolean
}

interface AccountFieldProps {
  title: string
  errors: any
  register: any
  fieldName: string
  isRequired?: string | boolean
  fieldType?: string
  readOnly?: boolean
}

const AccountField: React.FC<AccountFieldProps> = ({
  title,
  errors,
  register,
  fieldName,
  fieldType = 'text',
  readOnly = false
}) => (
  <label
    key={fieldName}
    className={classnames({ [styles.errorField]: errors[fieldName] })}
  >
    <span>{title}</span>
    <input
      type={fieldType}
      name={fieldName}
      ref={register}
      readOnly={readOnly}
    />
    <p className={styles.testFormError}>{errors[fieldName]?.message}</p>
  </label>
)

const Account: React.FC<AccountProps> = ({
  register,
  errors,
  handleContinue,
  password,
  isSubmitted
}) => {
  const isOnlyTab = !handleContinue
  return (
    <div>
      <div className={styles.signupForm}>
        <div>
          <AccountField
            title={t('First name')}
            fieldName="firstName"
            errors={errors}
            register={register({ required: 'Is required' })}
          />
          <AccountField
            title={t('Last name')}
            fieldName="lastName"
            errors={errors}
            register={register({ required: 'Is required' })}
          />
          <AccountField
            title={t('Email')}
            fieldType="email"
            fieldName="email"
            errors={errors}
            register={register({
              required: 'Is required',
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Please enter a valid email'
              }
            })}
            readOnly={isOnlyTab}
          />
          <AccountField
            title={t('Password')}
            fieldType="password"
            fieldName="password"
            errors={errors}
            register={register({
              required: 'Is required',
              minLength: {
                value: 7,
                message: 'Min length is 7'
              }
            })}
          />
          <AccountField
            title={t('Confirm Password')}
            fieldType="password"
            fieldName="passwordConfirm"
            errors={errors}
            register={register({
              validate: (value) =>
                value === password.current || 'The passwords do not match'
            })}
          />
          <AccountField
            title={t('Name of Church/Organization')}
            fieldName="organization"
            errors={errors}
            register={register({ required: 'Is required' })}
          />
        </div>
        {isOnlyTab ? (
          <button
            className={styles.button}
            type="submit"
            disabled={isSubmitted}
          >
            <span>{t('Activate My Account')}</span>
          </button>
        ) : (
          <div className={styles.button} onClick={() => handleContinue()}>
            <span>{t('Continue')}</span>
          </div>
        )}
      </div>
      <div className={styles.signupPicture}>
        <Image alt="Drummer" src={drummerImg} height={535} width={696} />
        {isOnlyTab && (
          <img className={styles.giftPicture} src="../images/gift.svg" />
        )}
      </div>
    </div>
  )
}

export default Account
